import * as Yup from 'yup'
import { useClearOnUnmount, useFieldHelpers } from '@/base'
import { Checkbox, CheckboxProps } from '../../atoms/checkbox'
import { FormField, FormFieldProps } from '.'

export const FormCheckbox = ({
  name,
  schema,
  shouldClearOnDismount,
  message,
  label,
  optionalText,
  description,
  ...rest
}: Omit<CheckboxProps, 'value' | 'onChange'> &
  Omit<FormFieldProps, 'children'> & {
    schema?: Yup.BooleanSchema
    shouldClearOnDismount?: boolean
  }) => {
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  return (
    <FormField
      name={name}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
    >
      <Checkbox
        value={field.value}
        checked={field.value}
        onCheckedChange={(checked) => helpers.setValue(checked)}
        label={label}
        {...rest}
      />
    </FormField>
  )
}
